module.exports = __webpack_public_path__ + "static/media/1600.b1630523.webp";